<template>
  <div>
    <!-- 杂志简介 -->
    <div class="evolution_middlenav" v-if="middle.brief">
      <div class="evolution_top">
        <div class="evolution_title">《中华消化外科杂志》简介(2020版)</div>
        <div class="evolution_toptxt">
          <div class="heng">
            <span class="txt_one">点击：9656</span>
            <span>更新日期：2020-01-02</span>
          </div>
        </div>
        <div class="evolution_top2">
          <div class="evolution_top2l">
            <img src="/src/assets/tu4.gif" alt="">
          </div>
          <div class="evolution_top2r">
            <div class="top_toptxt">
              <div class="r_toptxt1">中华消化外科杂志</div>
              <div class="r_toptxt2">Chinese Journal of Digestive Surgery</div>
            </div>
            <div class="bottom_toptxt">
              <ul class="bottom_ul1">
                <li>曾用名： 消化外科</li>
                <li>主办单位： 中华医学会</li>
                <li>出版周期： 月刊</li>
                <li>语种： 中文</li>
                <li>国际刊号： 1673-9752</li>
              </ul>
              <ul class="bottom_ul2">
                <li>影响因子： 3.58</li>
                <li>文献量： 4001</li>
                <li>被引量： 32711</li>
                <li>下载量： 455001</li>
                <li>基金论文量： 2106</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="evolution_bottom">
        《中华消化外科杂志》是由中国科学技术协会主管，中华医学会主办的国内唯一涵盖消化外科各领域的高水平的专业期刊。本刊为第3届全国百强期刊、百种中国杰出学术期刊、中国精品科技期刊、中国精品科技期刊顶尖学术论文(F5000)庆祝中华人民共和国成立70周年精品期刊、中国高校百佳科技期刊；已被《中文核心期刊要目总览》（2017年版）、中国科学引文数据库（CSCD<核心库>）、RCCSE中国核心学术期刊、美国《化学文摘（网络版）》（CA）、英国《国际农业与生物科学研究中心》（CABI）、世界卫生组织西太平洋地区医学索引（WPRIM）、日本科学技术振兴集团(中国)数据库(JSTChina)等17个等国内外著名检索系统收录。<br>
        《中华消化外科杂志》2019年度影响因子（核心版）为 2.418，在79种外科学类核心期刊中位列第一；综合评分为86.50分，在2 049种中国科技核心期刊（自然科学卷）中位列第28。本刊先后荣获中国高校科技期刊优秀团队、全军优秀医学期刊等殊荣；获2015、2016年度中华医学会系列杂志编辑出版质量评审一等奖、2019年度中华医学会系列杂志学术质量评审一等奖；获2012、2013、2015年度中国科协精品科技期刊工程项目3项课题资助；本刊所刊论文荣获中华医学百篇优秀论文、中国科协期刊优秀学术论文和多项重庆市期刊评审好作品、好栏目、好插图奖。<br>
        《中华消化外科杂志》办刊宗旨：传播国内外消化外科领域的新理论、新技术和新经验，立志成为联系国内外消化外科同道的纽带，推动我国消化外科学的发展。办刊方针：着重提高，兼顾普及。报道内容：涵盖消化外科各领域的基础与临床研究，包括食管、胃、肠、肝、胆、胰、脾、疝与腹壁外科及其相关的血管、内镜、介入治疗、外科营养支持、代谢外科等研究。栏目设置：院士论坛、述评、专家论坛、专家论坛.国际动态、专家论坛.热点对话、菁英论坛、专家点评、论著、论著.菁英荟研究报告、论著·外科天地、论著·影像集锦、论著.新技术、指南与共识、短篇论著、经验交流、病例报道、大巡诊、综述、争鸣、讲座、学术动态、读者来信等。 　　《中华消化外科杂志》总编辑为董家鸿教授。第三届编辑委员会由顾问25名、编委120名、通讯编委99名国内消化外科领域著名专家以及6名国际编委组成。第一届“中华消化外科菁英荟”由153名国内消化外科领域知名中青年外科医师组成。强大的学术阵容为《中华消化外科杂志》的学术质量提供了重要保障。 　　《中华消化外科杂志》编辑委员会每两年一次主办的“中国消化外科学术会议” 和“中国国际肝胆外科论坛”，目前已成为国内外消化外科界集学术争鸣、前沿探索、增进友谊和继续教育为一体的重要平台，对我国消化外科事业的发展起到了重要的推动作用。 　　《中华消化外科杂志》国内统一连续出版物号： CN 11-5610/R，国际标准连续出版物号：ISSN 1673-9752。国内邮发代号：78-117，国外邮发代号：M1813。月刊，A4开本，哑粉纸印刷，装订精良。每期80页，每月20日出版，每册定价20.00元。
      </div>
    </div>
    <!-- 发展大事记 -->
    <div class="middle_deeds" v-if="middle.Deeds">
      <div class="middle_one" v-if="!show2">
        <div class="middle_title">{{cename}}</div>
        <div class="middle_xian"></div>
      </div>
      <div class="deeds_list">
        <ul class="deeds_listul">
        	<li v-for="(item,index) in deeds" :key="index" @mouseover="addtop(1,index)" @mouseout="addtop(2,index)" :class="item.zt?'addbei':''" @click="jumpzn(item.filePath,item.channelId?item.channelId:item.channelID,item.contentId?item.contentId:item.id,item.dataType,item.year,item.issue,item.id)">
            <div class="deeds_left">
              <img :src="item.titlePhoto" alt="">
            </div>
            <div class="deeds_right" :class="small?'xiao':''">
              <div class="deeds_rightname" :class="item.zt?'add':''" v-if="searchtxt"><span v-html="brightenKeyword(item.title, searchtxt)"></span></div>
              <div class="deeds_rightname" :class="item.zt?'add':''" v-if="!searchtxt">{{item.title}}</div>
              <div class="deeds_righttxt">{{item.abstruct?item.abstruct:item.abstract}}</div>
              <div class="deeds_righttime">
                <div class="deeds_time">更新日期： {{item.addDate}}</div>
                <div class="deeds_num">点击量： {{item.hitCount}}</div>
               </div>
            </div>
          </li>
        </ul>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage3"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 外科天地 -->
    <div class="middle_deeds" v-if="middle.video">
      <div class="middle_one">
        <div class="middle_title" style="width: auto;display: inline-block;padding-bottom: 13px;border-bottom: 3px solid var(--xt);">{{cename}}</div>
      </div>
      <div class="deeds_list">
        <ul class="deeds_listul">
          <li v-for="(item,index) in video" :key="index" @mouseover="addtop2(1,index)" @mouseout="addtop2(2,index)" @click="jump(item.contentId)">
            <div class="deeds_left">
              <img :src="item.titlePhoto" alt="">
            </div>
            <div class="deeds_right" :class="small?'xiao':''">
              <div class="deeds_rightname" :class="item.zt?'add':''" style="margin-bottom: 21px;">{{item.title}}</div>
              <div class="deeds_righttxt">讲者: {{item.author}}</div>
              <div class="deeds_righttxt" v-if="item.organization">单位: {{item.organization}}</div>
              <div class="deeds_righttime">
                <div class="deeds_time">更新日期： {{item.addDate}}</div>
                <div class="deeds_num" v-if="!people">点击量： {{item.hitCount}}</div>
                <div class="deeds_num" v-if="people"><span class="iconfont iconrentou" style="margin-right: 5px;"></span>{{item.hitCount}}</div>
               </div>
            </div>
          </li>
        </ul>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage3"
          :page-size="9"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>

 export default {
  props: ['middle','video','cename','deeds','show2','searchtxt','people','totalcount','small'],
  data () {
    return {
      hide: false,
      show: false,
      currentPage3: 1,//当前页数
      total: 0,//总条数
    }
  },
  watch:{
    totalcount(){
      console.log(this.totalcount,'zhixing');
      this.total = this.totalcount;
    }
  },
  methods:{
    //文件下载
    GetContentFilePath(contentId,downType){
      var that = this;
      that.$httphelper.GetContentFilePath({
        "journalId": that.$_JournalId,
        "contentId": contentId,
        "downType": downType
      }).then(res => {
        if(res.code==200){
          window.open(res.data);
          that.$loading.hideLoading();
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    //更新点击量
    GetGotoFilePath(contentId,downType){
      var that = this;
      that.$httphelper.GetGotoFilePath({
        "journalId": that.$_JournalId,
        "contentId": contentId,
        "downType": downType
      }).then(res => {
        if(res.code==200){
          window.open(res.data);
          that.$loading.hideLoading();
          window.location.reload()
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    //关键词变色
    brightenKeyword(val, keyword) {
      // 方法2：用正则表达式
      const Reg = new RegExp(keyword, "i");
      if (val) {
        const res = val.replace(
          Reg,
          `<span style="color: var(--xt);">${keyword}</span>`
        );
        return res;
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage3 = val;
      this.$emit("currentPage3",this.currentPage3);
      console.log(`当前页: ${val}`);
    },
    //页面初始化
    index(){
      console.log(this.totalcount,'smallsmallsmallsmall');
      var that = this;
      this.total = this.totalcount;
    },
    //发展大事记鼠标悬停
    addtop(num,id){
      if(num==1){
        for(var i=0;i<this.deeds.length;i++){
          if(id==i){
            this.deeds[i].zt = true;
            this.deeds.push('1');
            this.deeds.pop('1');
          }
        }
      }else{
        for(var i=0;i<this.deeds.length;i++){
          this.deeds[i].zt = false;
          this.deeds.push('1');
          this.deeds.pop('1');
        }
      }
    },
    //外科天地鼠标悬停
    addtop2(num,id){
      if(num==1){
        for(var i=0;i<this.video.length;i++){
          if(id==i){
            this.video[i].zt = true;
            this.video.push('1');
            this.video.pop('1');
          }
        }
      }else{
        for(var i=0;i<this.video.length;i++){
          this.video[i].zt = false;
          this.video.push('1');
          this.video.pop('1');
        }
      }
    },
    //外科天地跳转详情
    jump(contentId){
      if(this.cename=='视频'){
        this.$router.push({path:'/surgery_details',query:{contentId:contentId}});
      }else if(this.cename=='课件'){
        //调取下载接口
        this.GetContentFilePath(contentId,2);
      }
    },
    //指南与共识跳转pdf
    jumpzn(filePath,channelId,contentId,dataType,year,issue,id){
      if(this.cename=='病例分享'){
        if(!contentId){
          contentId = 0;
        }
        this.$router.push({path:'/browse_details',query:{year:year,issue:issue,issuecid:contentId}});
      }else if(this.cename=='指南与共识'){
        this.GetGotoFilePath(contentId,1);
      }else if(this.cename=='学术会议'){
        this.$router.push({path:'/expert_details',query:{num: 5,contentId:contentId,channelId:channelId}});
      }else if(this.cename=='编辑委员会会议'){
        this.$router.push({path:'/expert_details',query:{num: 6,contentId:contentId,channelId:channelId}});
      }else if(this.cename=='搜索'){
        console.log(dataType,'类型')
        if(dataType==1){
          this.$router.push({path:'/expert_details',query:{num: 10,contentId: contentId,channelId:channelId}});
        }else if(dataType==2){
          this.$router.push({path:'/surgery_details',query:{contentId:contentId}});
        }else if(dataType==3){
          this.$router.push({path:'/browse_details',query:{year:year,issue:issue,issuecid:id}});
        }
      }
    }
  },
  created() {
    this.index();
  },
}
</script>

<style lang="scss" scoped>
*{
  padding: 0;
  margin: 0;
}
.evolution_middlenav{
   width: 100%;
   overflow: hidden;
   .evolution_top{
     width: 93%;
     margin: 0 auto;
     padding-bottom: 36px;
     border-bottom: 1px solid #F6F6F6;
     .evolution_title{
       width: 100%;
       text-align: center;
       font-size: 24px;
       font-family: Source Han Sans SC;
       font-weight: bold;
       color: #000000;
       margin-bottom: 19px;
     }
     .evolution_toptxt{
       width: 100%;
       overflow: hidden;
       background-color: #F5F5F5;
       .heng{
         width: 55%;
         margin: 0 auto;
         text-align: center;
         font-size: 16px;
         font-family: Adobe Heiti Std;
         font-weight: normal;
         color: #000000;
         line-height: 30px;
         .txt_one{
           margin-right: 30px;
         }
       }
     }
     .evolution_top2{
       width: 100%;
       overflow: hidden;
       margin-top: 40px;
       .evolution_top2l{
         width: 25%;
         float: left;
         margin-right: 2%;
         img{
           width: 100%;
           height: 264px;
         }
       }
       .evolution_top2r{
         width: 73%;
         float: left;
         .top_toptxt{
           width: 100%;
           margin-bottom: 30px;
           .r_toptxt1{
             font-size: 20px;
             font-family: Adobe Heiti Std;
             font-weight: normal;
             color: #000000;
             line-height: 30px;
           }
           .r_toptxt2{
             font-size: 16px;
             font-family: Adobe Heiti Std;
             font-weight: normal;
             color: #000000;
             line-height: 30px;
           }
         }
         .bottom_toptxt{
           width: 100%;
           overflow: hidden;
           .bottom_ul1,.bottom_ul2{
             float: left;
             list-style: none;
             li{
               font-size: 16px;
               font-family: Adobe Heiti Std;
               font-weight: normal;
               color: #000000;
               line-height: 30px;
             }
           }
           .bottom_ul1{
             width: 70%;
           }
           .bottom_ul2{
             width: 30%;
           }
         }
       }
     }
   }
   .evolution_bottom{
     width: 93%;
     margin: 0 auto;
     margin-top: 41px;
     font-size: 16px;
     font-family: Adobe Heiti Std;
     font-weight: normal;
     color: #000000;
     line-height: 30px;
   }
}
.middle_deeds{
  width: 100%;
  .middle_one{
    width: 100%;
    position: relative;
    padding-bottom: 9px;
    .middle_title{
      font-size: 24px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      color: #000000;
    }
    .middle_xian{
      width: 123px;
      height: 3px;
      background-color: var(--biao);
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
  .deeds_list{
    width: 100%;
    overflow: hidden;
    .deeds_listul{
      width: 100%;
      list-style: none;
      overflow: hidden;
      li{
        width: 99%;
        overflow: hidden;
        border-bottom: 1px solid #EBEBEB;
        padding: 24px 1.5% 24px 1.5%;
        margin-right: 1%;
        cursor: pointer;
        .deeds_left{
          width: 196px;
          margin-right: 2%;
          float: left;
          img{
            width: 100%;
            height: 130px;
            object-fit: cover;
          }
          img:hover{
            transform: scale(1.03);
          }
        }
        .deeds_right{
          width: 76%;
          float: left;
          .deeds_rightname{
            width: 100%;
            font-size: 18px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #000000;
            margin-bottom: 5px;
          }
          .deeds_righttxt{
            width: 100%;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #757575;
            line-height: 24px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            margin: 8px 0;
          }
          .deeds_righttime{
            width: 100%;
            overflow: hidden;
            .deeds_time{
              width: 50%;
              float: left;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #757575;
              line-height: 28px;
            }
            .deeds_num{
              width: 50%;
              text-align: right;
              float: left;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #757575;
              line-height: 28px;
            }
          }
        }
      }
    }
    .el-pagination{
      text-align: center;
      margin-top: 30px;
    }
  }
}

@media only screen and (min-width: 1200px) {
  .deeds_left{
    width: 170px!important;
  }
}


.add{
  color: var(--xt)!important;
}
.addbei{
  background: #FAFAFA;
}
.xiao{
  width: 70%!important;
}
</style>



// WEBPACK FOOTER //
// src/components/public/evolution/evolution_nav.vue